/**
 * Calculator lookup helpers, icons and "recently used" storage
 */

import React from 'react';
import GridOnRoundedIcon from '@mui/icons-material/GridOnRounded';
import ViewModuleRoundedIcon from '@mui/icons-material/ViewModuleRounded';
import RoofingRoundedIcon from '@mui/icons-material/RoofingRounded';
import ViewInArRoundedIcon from '@mui/icons-material/ViewInArRounded';
import VerticalShadesRoundedIcon from '@mui/icons-material/VerticalShadesRounded';
import TerrainRoundedIcon from '@mui/icons-material/TerrainRounded';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import FoundationRoundedIcon from '@mui/icons-material/FoundationRounded';
import FormatPaintRoundedIcon from '@mui/icons-material/FormatPaintRounded';
import { CATEGORIES, MATERIALS } from '../../utils/materialEstimatorData';

export const CATEGORY_ICONS = {
  walls: <GridOnRoundedIcon />,
  floors: <ViewModuleRoundedIcon />,
  roofing: <RoofingRoundedIcon />,
  concrete: <ViewInArRoundedIcon />,
  ceiling: <VerticalShadesRoundedIcon />,
  earthwork: <TerrainRoundedIcon />,
  surveying: <ExploreRoundedIcon />,
  foundation: <FoundationRoundedIcon />,
  plastering: <FormatPaintRoundedIcon />,
};

// Order categories by how often people building a house need them
export const CATEGORY_ORDER = ['walls', 'floors', 'concrete', 'foundation', 'roofing', 'plastering', 'ceiling', 'earthwork', 'surveying'];

/** Flat list of all calculators with their category */
export const ALL_CALCULATORS = CATEGORY_ORDER.flatMap((catId) =>
  Object.values(MATERIALS[catId] || {}).map((m) => ({ ...m, categoryId: catId, category: CATEGORIES[catId] }))
);

export const findCalculator = (id) => ALL_CALCULATORS.find((c) => c.id === id) || null;

/** Match against English and Malay names, category and description */
export const matchesSearch = (calc, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const haystack = [
    calc.label,
    calc.labelMy,
    calc.category?.label,
    calc.category?.labelMy,
    calc.category?.description,
    calc.category?.descriptionMy,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return q.split(/\s+/).every((word) => haystack.includes(word));
};

const RECENT_KEY = 'rumahkira_recent_calculators';

export const getRecentCalculators = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    return ids.map(findCalculator).filter(Boolean);
  } catch {
    return [];
  }
};

export const addRecentCalculator = (id) => {
  try {
    const ids = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').filter((x) => x !== id);
    localStorage.setItem(RECENT_KEY, JSON.stringify([id, ...ids].slice(0, 6)));
  } catch {
    // ignore storage errors
  }
};
